import { getFallbackPricingData } from '../services/stripeService';

export const CREATE_CHECKOUT_REQUEST = 'CREATE_CHECKOUT_REQUEST';
export const CREATE_CHECKOUT_SUCCESS = 'CREATE_CHECKOUT_SUCCESS';
export const CREATE_CHECKOUT_ERROR = 'CREATE_CHECKOUT_ERROR';

export const initialState = {
  plans: getFallbackPricingData(),
  isCreatingCheckout: false,
  checkoutError: null,
  lastCheckoutSession: null,
};

export const createCheckoutRequest = () => ({
  type: CREATE_CHECKOUT_REQUEST,
});

export const createCheckoutSuccess = (session) => ({
  type: CREATE_CHECKOUT_SUCCESS,
  payload: { session },
});

export const createCheckoutError = (error) => ({
  type: CREATE_CHECKOUT_ERROR,
  payload: { error },
});

const pricingReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CHECKOUT_REQUEST:
      return {
        ...state,
        isCreatingCheckout: true,
        checkoutError: null,
      };

    case CREATE_CHECKOUT_SUCCESS:
      return {
        ...state,
        isCreatingCheckout: false,
        lastCheckoutSession: action.payload.session,
        checkoutError: null,
      };

    case CREATE_CHECKOUT_ERROR:
      return {
        ...state,
        isCreatingCheckout: false,
        checkoutError: action.payload.error,
      };

    default:
      return state;
  }
};

export default pricingReducer;
